/*
  Font tracking
  Implements font tracking asynchronously in a way that can be bundled with the current gulp/bundle-config setup.
*/

(function () {
  var projectId = 'f9dec64f-3f4b-46e9-977b-518c2d335e20';
  var mtiTracking = document.createElement('link');
  mtiTracking.type = 'text/css';
  mtiTracking.rel = 'stylesheet';
  mtiTracking.href = 'https://fast.fonts.net/t/1.css?apiType=css&projectid=' + projectId;
  (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(mtiTracking);
})();